//separated this into its own file as this logic is shared between TransitTracker and MapsAndSchedules

export const ctSwiftRoutes = _routes.filter(x => x.route_short_name.toLowerCase().includes('swift'))
    .map(x => ({route_id: x.route_id,
                url: x.route_id === '701' ? "/ResourcePackages/Bootstrap4/assets/dist/sprites/swiftblue.svg"
                : x.route_id === '702' ? "/ResourcePackages/Bootstrap4/assets/dist/sprites/swiftgreen.svg"
                : x.route_id === '703' ? "/ResourcePackages/Bootstrap4/assets/dist/sprites/swiftorange.svg"
                : "/ResourcePackages/Bootstrap4/assets/dist/sprites/swiftgold.svg"}));
export const ctSwiftRouteIds = ctSwiftRoutes.map(x => x.route_id);

export const getSwiftIconForRoute = (route_id) => {
    const route = ctSwiftRoutes.find(r => r.route_id == route_id);

    if (route && route.url) {
        return route.url;
    }

    return null;
};

export const updateSwiftStop = (stop)=> {
    if (stop.routes_served.some(r_id => ctSwiftRouteIds.includes(r_id)))
    {
        const icons = [];
        for (let i = 0; i < ctSwiftRoutes.length; i++) {
            if (stop.routes_served.includes(ctSwiftRoutes[i].route_id)) {
                icons.push(ctSwiftRoutes[i].url);                
            }
        }

        return {...stop, isSwift: true, icons};
    } else {
        return stop;
    }
}